<script>
  // based on suggestions from:
  // Inclusive Components by Heydon Pickering https://inclusive-components.design/collapsible-sections/
  export let headerText;

  let expanded = false;
</script>

<style style="text/scss" lang="scss">
  .subheader {
    margin-bottom: 0 !important;
  }
  button {
    background-color: var(--background, #fff);
    color: var(--gray-darkest, #282828);
    display: flex;
    justify-content: space-between;
    width: 100%;
    border: none;
    margin: 0;
    padding: 0;
  }

  button[aria-expanded='true'] .vert {
    display: none;
  }

  button[aria-expanded='true'] {
    margin-bottom: 10px;
  }
  svg {
    height: 0.7em;
    width: 0.7em;
  }
</style>

<div class="section">
  <button aria-expanded={expanded} on:click={() => (expanded = !expanded)}
    ><h3 class="subheader">{headerText}</h3>
    <svg viewBox="0 0 20 20" fill="none">
      <path class="vert" d="M10 1V19" stroke="black" stroke-width="2" />
      <path d="M1 10L19 10" stroke="black" stroke-width="2" />
    </svg>
  </button>

  <div class="contents" hidden={!expanded}>
    <slot />
  </div>
</div>
